import type {FC} from 'react';
import moment from 'moment';
import {Stack} from '@wellstone-solutions/web';
import type {ContactNote} from 'api/v2';
import {DATE_FORMAT_LONG} from '../../constants';
import {InfoRow} from '../SessionDocumentList/DocumentCell';
import {getServiceCodeLabel} from './utils';

type NoteCellProps = {
  note: ContactNote;
};

export const NoteCell: FC<NoteCellProps> = ({note}) => (
  <Stack sx={{justifyContent: 'center', height: '100%', width: '100%'}}>
    <InfoRow
      label="Date of Service"
      value={moment(note.dateOfService).format(DATE_FORMAT_LONG)}
    />
    <InfoRow label="Member" value={note.member.name} />
    <InfoRow label="Support Staff" value={note.staff.name} />
    <InfoRow label="Service code" value={getServiceCodeLabel(note)} />
  </Stack>
);
